import React, { useEffect, useRef } from 'react';
import { toTradingViewSymbol, toTradingViewTechnicalsUrl } from './tradingViewUtils';

const EMBED_SCRIPT = 'https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js';

/**
 * props:
 * - symbol
 */
function TechnicalAnalysisWidget(props) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    container.innerHTML = '';

    const widgetHost = document.createElement('div');
    widgetHost.className = 'tradingview-widget-container__widget';

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = EMBED_SCRIPT;
    script.async = true;
    script.innerHTML = JSON.stringify({
      interval: '1h',
      width: '100%',
      isTransparent: false,
      height: '100%',
      symbol: toTradingViewSymbol(props.symbol),
      showIntervalTabs: true,
      displayMode: 'multiple',
      locale: 'en',
      colorTheme: 'light',
    });

    const wrapper = document.createElement('div');
    wrapper.className = 'tradingview-widget-container tradingview-panel-embed';
    wrapper.appendChild(widgetHost);
    wrapper.appendChild(script);
    container.appendChild(wrapper);

    return () => {
      container.innerHTML = '';
    };
  }, [props.symbol]);

  return (
    <div className="technical-analysis-panel">
      <div className="d-flex justify-content-between align-items-center mb-3 px-1">
        <p className="text-muted small mb-0">
          Oscillator and moving-average ratings for {props.symbol}
        </p>
        <a
          href={toTradingViewTechnicalsUrl(props.symbol)}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-sm btn-outline-primary"
        >
          Open in TradingView
        </a>
      </div>
      <div ref={containerRef} className="technical-analysis-embed-host" />
    </div>
  );
}

export default TechnicalAnalysisWidget;